export const submitTypePrice = "travelPrice";
export const submitTypeTravelNumber = "travelNumber";
